export { default as ProfileIdentificationLegal}  from "./profile-identification-legal.vue"
export { default as ProfileIdentificationNatural } from "./profile-identification-natural.vue"
export * from "./adapter"
